import { Options, Vue } from 'vue-class-component';
import PageTitleComponent from '@/sharedcomponents/pageComponents/pageTitle/PageTitleComponent.vue';
import InsurancesProductEnum from '@/enums/InsurancesProductEnum';
import BuyCarComponent from './car/BuyCarComponent.vue';
import BuyAccidentComponent from './accident/BuyAccidentComponent.vue';
import BuyAccidentChildrenComponent from './accidentChildren/BuyAccidentChildrenComponent.vue';
import BuyHomeComponent from './home/BuyHomeComponent.vue';
import BuyHouseComponent from './house/BuyHouseComponent.vue';
import BuyTravelComponent from './travel/BuyTravelComponent.vue';
import BuyDogComponent from './dog/BuyDogComponent.vue';
import BuyFamilyComponent from './family/BuyFamilyComponent.vue';
import ContactComponent from './components/ContactComponent.vue';
import {
	UPDATE_ACTIVE_CALCULATOR,
	CALCULATOR_LOADED,
	BASKET_LOADED,
	RESET_CALCULATORS,
} from '@/store/modules/calculatorContext';
import BasketWidgetComponent from './components/BasketWidgetComponent.vue';
import BasketComponent from './basket/BasketComponent.vue';
import {
	CalculatorPage,
	HtmlBlock,
	CardBlock,
	HeaderCardBlock,
	CampaignPackagesBlock,
	CampaignFlatRateBlock,
	AlertBlock,
} from '@/cms/definitions/content-types';
import store from '@/store/store';
import CookieFooter from '@/sharedcomponents/pageComponents/cookieFooter/cookieFooter.vue';
import { sendMailLead } from './services/OrderService';
import { loadCustomer } from './services/UserLoginService';
import { AppSendMessage, isApp } from '@/views/calculators/services/environmentService';
import { mapState } from 'vuex';
import Menu from '@/sharedcomponents/pageComponents/menu/Menu.vue';
import { trackBeginCheckoutViewItem, trackLoadInsurance } from '@/views/calculators/services/trackingUtility';
import { handleNavigationTracking } from './services/NavigationService';
import UsabillaInPageComponent from '@/sharedcomponents/pageComponents/usabillaInPageComponent/UsabillaInPageComponent.vue';
import { information } from '@/appinsights/logging/ApplicationInsightLog';
import { initConsent, addHeaderCardBlock } from './services/ProductService';
import AxiosService from './services/axiosService';
export interface CalculatorUiComponent {
	model: any;
	cms: any;
	buildDescriptionForEmail: Function;
	addResetSubscription: Function;
	calculator: Calculator;
	$route;
	gotoCard(cardName: string);
}

export interface Calculator {
	axiosService: AxiosService;
	model;
	cms;
	calcConfig;
	successCalc?: boolean;
	calculatorInfo: Array<any>;
	setUpConfig(): void;
	setupExcessList(): void;
	getCalculations(excessId?: number): Promise<boolean>;
	onePackageCalcEpi?(
		monthly: boolean,
		excessId: number,
		packageId: number,
		specialDiscount?: number
	): Promise<boolean>;
}
@Options({
	name: 'BuyInsuranceComponent',
	components: {
		PageTitleComponent,
		BuyCarComponent,
		BuyAccidentComponent,
		BuyAccidentChildrenComponent,
		BuyHomeComponent,
		BuyHouseComponent,
		BuyTravelComponent,
		BasketComponent,
		BuyFamilyComponent,
		BuyDogComponent,
		ContactComponent,
		BasketWidgetComponent,
		Menu,
		CookieFooter,
		UsabillaInPageComponent,
	},
	computed: mapState<any>({
		menuModel: (state) => state.menuModel,
	}),

	props: {
		model: Object,
	},
})
export default class BuyInsuranceComponent extends Vue {
	public menuModel!: Array<any>;

	model: CalculatorPage; // epi contentModel

	public contentBlocks: Array<CardBlock> = [];
	public receiptBlock: CardBlock;
	public settingsBlock: HtmlBlock;
	public campaignBlocks: Array<CampaignFlatRateBlock | CampaignPackagesBlock> = [];
	public alertBlock: AlertBlock = null;
	public calculatorInfoBlock: HtmlBlock;
	public usabillaBlock: any = null;
	public usabillaProductBlock: any = null;
	public contentBlocksLoaded = false;

	public cms: any = null; // from the selected calculator store, used for content i contact component
	public productName: string = null;
	public renderPage = false;
	public headerCards: Map<string, string> = new Map();
	public preTitle = '...';
	public mainTitle = '...';
	public loadingAgreements = false;
	public static sendLeadMail = true;
	private static onBeforeLoadRegistered = false;

	public beforeCreate() {
		const unsubscribe = store.subscribeAction((action, state) => {
			if (action.type === CALCULATOR_LOADED || action.type === BASKET_LOADED) {
				this.cms =
					action.type === CALCULATOR_LOADED
						? store.getters.getActiveCalculator.cms
						: store.getters.getBasket.cms;
				this.handleUser();
				this.handleTitlesAndFirstFocus();
				this.renderPage = true;
				this.setupMailLead();
				if (this.productName === 'kurv') {
					// DEBUG const idName = 'overview_basket';
					// DEBUG trackViewCard(idName, idName, false).then( () => trackViewItemList(idName, idName,true,false).then( () => trackBeginCheckoutViewItem(this.productName,true)));
					trackBeginCheckoutViewItem(this.productName, true);
				} else {
					trackLoadInsurance(this.productName, this.cms.defaultCard).then(() =>
						trackBeginCheckoutViewItem(this.productName, true)
					);
				}
				// DEBUG trackBeginCheckout(this.productName);
				unsubscribe();
				// only relevant on direct pageLoad
				setTimeout(() => {
					if (!store.state.trackingContext.isFirstPageEventFired) {
						information('FirstPageLoad Fired From product');

						handleNavigationTracking();
					}
				}, this.cms.animationTimeout);
				// don't wait
				initConsent(this.cms);
			}
		});
		store.subscribeAction((action, state) => {
			if (action.type === RESET_CALCULATORS) {
				// don't send leadMail, customer has ordered product(s)
				BuyInsuranceComponent.sendLeadMail = false;
				// don't show productUsabilla
				this.usabillaProductBlock = undefined;
			}
		});
	}

	public beforeMount() {
		addEventListener('resize', this.handleTitlesAndFirstFocus);
	}

	public mounted() {
		this.initMounted();
	}
	private async initMounted() {
		this.productName = this.model.preTitle.toLocaleLowerCase();
		if (this.productName !== 'kurv') {
			await store.dispatch(UPDATE_ACTIVE_CALCULATOR, this.productName);
		}
		// if reentrant make sure missingCalculationsInBasket is false
		store.state.missingCalculationsInBasket = false;
		this.handleContentBlocks();
	}

	public get showSpinner() {
		return store.state.showSpinner;
	}
	public get calculating() {
		return store.state.showSpinner && store.state.calculatorContext.calculating;
	}

	public get isLoggedInAsApp() {
		return isApp();
	}

	private async handleUser() {
		this.loadingAgreements = true;
		await loadCustomer(this.cms);
		this.loadingAgreements = false;
		BuyInsuranceComponent.sendLeadMail = this.cms.sendLeadMail;
	}

	private setupMailLead() {
		if (BuyInsuranceComponent.onBeforeLoadRegistered) {
			return;
		}
		addEventListener('beforeunload', (evt) => {
			if (BuyInsuranceComponent.sendLeadMail) {
				BuyInsuranceComponent.sendLeadMail = false;
				sendMailLead();
			}
			return undefined;
		});
		BuyInsuranceComponent.onBeforeLoadRegistered = true;
	}

	public beforeUnmount() {
		removeEventListener('resize', this.handleTitlesAndFirstFocus);
	}

	private handleTitlesAndFirstFocus() {
		const calculatorInx = store.getters.getActiveCalculatorInx;
		let calcNo = '';
		if (calculatorInx > 0 && this.productName !== 'kurv') {
			calcNo = ' ' + (calculatorInx + 1);
		}

		try {
			if (isApp()) {
				this.preTitle = undefined; // Not used in App
				this.mainTitle = this.cms.shortTitle;
				this.mainTitle += calcNo;
				AppSendMessage({ MAIN_TITLE: this.model.mainTitle });
			} else if (screen.width < 768) {
				this.preTitle = this.cms.shortTitle + calcNo;
				this.mainTitle = this.cms.shortTitle === 'Kurv' ? this.model.mainTitle : this.cms.shortMainTitle;
			} else {
				this.preTitle = this.model.preTitle + calcNo;
				this.mainTitle = this.model.mainTitle;
			}
		} catch (error) {
			this.preTitle = this.model.preTitle + calcNo;
			this.mainTitle = this.model.mainTitle;
		}

		// skip focus on first field in product if app or short screen
		if (this.cms.focusFirstFieldDesktop && (isApp() || screen.height < 900 || innerHeight < 700)) {
			this.cms.focusFirstField = false;
		} else {
			this.cms.focusFirstField = true;
		}
	}

	private handleContentBlocks() {
		const blocks: Array<CardBlock> = [];
		this.settingsBlock = { markup: '' } as HtmlBlock;
		this.calculatorInfoBlock = { markup: '' } as HtmlBlock;
		this.campaignBlocks = [];
		this.model.mainArea.forEach((block) => {
			if (block.contentType === 'CardBlock') {
				if (block.name === 'receipt' || block.name === 'reciept') {
					this.receiptBlock = block as CardBlock;
					this.receiptBlock.name = 'receipt';
				} else {
					blocks.push(block as CardBlock);
				}
			} else if (block.contentType === 'HeaderCardBlock') {
				// OBSOLETE - to be removed when no longer used in cms, header cards should be added to headerCards map in ProductService and rendered in header component
				const headerBlockObsolete = block as HeaderCardBlock;
				addHeaderCardBlock(headerBlockObsolete.text, headerBlockObsolete.css, headerBlockObsolete.id, this);
			} else if (block.contentType === 'HtmlBlock') {
				if (block.name.toLocaleLowerCase() === 'global settings') {
					// global settings first
					this.settingsBlock.markup = (block as HtmlBlock).markup + this.settingsBlock.markup;
				} else if (block.name.toLocaleLowerCase().endsWith('settings')) {
					this.settingsBlock.markup += (block as HtmlBlock).markup;
				} else if (block.name.toLocaleLowerCase().endsWith('calculatorinfo')) {
					this.calculatorInfoBlock.markup += (block as HtmlBlock).markup;
				}
			} else if (block.contentType === 'UsabillaInPageBlock') {
				const usabillaId = (block as any)?.usabillaId;
				switch (usabillaId) {
					case store.state.UsabillaReceiptId:
						this.usabillaBlock = block;
						break;
					case store.state.UsabillaProductId:
						this.usabillaProductBlock = block;
						break;
					default:
						break;
				}
			} else if (block.contentType === 'CampaignPackagesBlock' || block.contentType === 'CampaignFlatRateBlock') {
				const campaignBlock = block as CampaignFlatRateBlock;
				addHeaderCardBlock(campaignBlock.bannerText, campaignBlock.css, campaignBlock.campaignId, this);
				this.campaignBlocks.push(block as CampaignPackagesBlock | CampaignFlatRateBlock);
			} else if (block.contentType === 'AlertBlock') {
				this.alertBlock = block as AlertBlock;
			}
		});
		this.contentBlocks = blocks;
		this.contentBlocksLoaded = true;
	}

	public get isCar(): boolean {
		return this.productName === InsurancesProductEnum.BIL_FORSIKRING;
	}
	public get isAccident(): boolean {
		return this.productName === InsurancesProductEnum.ULYKKES_FORSIKRING;
	}
	public get isAccidentChildren(): boolean {
		return this.productName === InsurancesProductEnum.BOERNEULYKKES_FORSIKRING;
	}
	public get isHome(): boolean {
		return this.productName === InsurancesProductEnum.INDBO_FORSIKRING;
	}
	public get isFamily(): boolean {
		return this.productName === InsurancesProductEnum.BOERNE_FAMILIE_FORSIKRING;
	}
	public get isHouse(): boolean {
		return (
			this.productName === InsurancesProductEnum.HUS_FORSIKRING ||
			this.productName === InsurancesProductEnum.FRITIDSHUS_FORSIKRING
		);
	}
	public get isTravel(): boolean {
		return this.productName === InsurancesProductEnum.REJSE_FORSIKRING;
	}
	public get isDog(): boolean {
		return this.productName === InsurancesProductEnum.HUNDE_FORSIKRING;
	}
	public get isBasket(): boolean {
		return this.productName === 'kurv';
	}
}
